import { render, staticRenderFns } from "./discounts-coupons.vue?vue&type=template&id=0cab06c0&"
import script from "./discounts-coupons.vue?vue&type=script&lang=js&"
export * from "./discounts-coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports